import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { logout } from "../../actions/authActions";
import LoggedInMenu from "../../components/LoggedInMenu/LoggedInMenu";
import RoofSnapDrawer from "../../components/RoofSnapDrawer/RoofSnapDrawer";
import SearchAppBar from '../SearchAppBar';
import OrdersTabs from '../OrdersTabs';

const style = () => ({
    flex: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
});

export class RoofSnapAppBar extends Component {
    state = {
        drawerOpen: false,
        searchBarOpen: false,
        urlToReturnTo: '/'
    };

    constructor(props) {
        super(props);
        this.handleOnDismissSearchBarClick = this.handleOnDismissSearchBarClick.bind(this);
    }

    componentDidMount() {
        // determine if we are on the search page. If so, show the search bar
        if (this.props.location.pathname === '/searchorders') {
            this.setState({
                searchBarOpen: true
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            if (this.props.location.pathname === '/searchorders') {
                this.setState({
                    searchBarOpen: true,
                })
            } else {
                this.setState({
                    searchBarOpen: false,
                })
            }
        }
    }

    logout = () => {
        this.props.dispatch(logout());
    };

    toggleOpenDrawer = () => {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    };

    showSearchBar = () => {
        this.setState({
            urlToReturnTo: `${this.props.location.pathname}${this.props.location.search}`
         });

        this.props.history.push('/searchorders');
    };

    handleOnDismissSearchBarClick = () => {
        this.setState({ searchBarOpen: false });

        this.props.history.push(this.state.urlToReturnTo);
    };

    render() {
        const isRoofSnapAdmin = (this.props.currentUserRoles.isSketchOsAdmin || this.props.currentUserRoles.isAdmin);

        return (
            <div>
                <RoofSnapDrawer open={this.state.drawerOpen} onToggle={this.toggleOpenDrawer} currentUserRoles={this.props.currentUserRoles} />
                <AppBar position="fixed">
                    <Toolbar>
                        {
                            this.props.isAuthenticated &&
                            <IconButton onClick={this.toggleOpenDrawer} className={this.props.classes.menuButton} color="inherit" aria-label="Menu">
                                <MenuIcon />
                            </IconButton>
                        }
                        <Typography variant="h6" color="inherit" className={this.props.classes.flex}>
                            Sketch Tech Dashboard
                        </Typography>
                        {
                            (this.props.isAuthenticated && isRoofSnapAdmin) &&
                            <IconButton
                                color="inherit"
                                aria-label="Search"
                                onClick={this.showSearchBar}
                            >
                                <SearchIcon />
                            </IconButton>
                        }
                        {
                            this.props.isAuthenticated &&
                            <LoggedInMenu
                                onLogoutClick={this.logout}
                                currentUser={this.props.currentUser }
                                position={this.props.currentUserRoles.position}
                            />
                        }
                    </Toolbar>
                    {
                        (this.props.isAuthenticated && this.props.location.pathname !== '/') &&
                        <OrdersTabs />
                    }
                </AppBar>
                <SearchAppBar
                    show={this.state.searchBarOpen}
                    onDismissClick={this.handleOnDismissSearchBarClick}
                />
            </div>
        );
    }
}

RoofSnapAppBar.propTypes = {
    dispatch: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        flex: PropTypes.string.isRequired,
        menuButton: PropTypes.string.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    currentUser: PropTypes.shape({
        userName: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    }).isRequired,
    currentUserRoles: PropTypes.shape({
        isAdmin: PropTypes.bool.isRequired,
        isSketchOsAdmin: PropTypes.bool.isRequired,
        isSketchTech: PropTypes.bool.isRequired,
        position: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string
    }).isRequired
};

const mapStateToProps = (state) => {
    const { auth, currentUser, currentUserRoles } = state;
    const { isAuthenticated } = auth;

    return {
        isAuthenticated,
        currentUser,
        currentUserRoles
    }
};

export default withRouter(withStyles(style)(connect(mapStateToProps)(RoofSnapAppBar)));
